import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';


export default function AlertDialog({title,
                                     content,
                                     mainButton,
                                     open,
                                     onClose}) {

    return (
      <React.Fragment>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: {
              borderRadius: 2,
              boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.3)',
            }
          }}
        >
          <DialogTitle id="alert-dialog-title" sx={{
            backgroundColor: '#EF7F95',
            color: '#fff',
            fontWeight: 'bold',
          }}>
            {title}
          </DialogTitle>
          <DialogContent>
            <Typography sx={{
                whiteSpace: 'pre-line',
                wordBreak: 'break-word',
                mt: 2,
                color: 'text.primary',
            }}>
                {content}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button 
              onClick={onClose} 
              autoFocus
              variant="contained"
              sx={{
                backgroundColor: '#EF7F95',
                color: '#fff',
                '&:hover': {
                  backgroundColor: alpha('#EF7F95', 0.8),
                },
              }}
            >
              {mainButton}
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }